<template>
  <div class="certification-page">
    <TopTitle title="企业信息" />
    <el-tabs v-model="activeName">
      <el-tab-pane label="企业认证" name="1">
        <!-- 认证流程-1填写企业名称 -->
        <div class="certifica-result-nav" v-if="stepIndex === 1">
          <div class="result-title">企业状态：未认证</div>
          <p>完成企业认证，你可解锁完整E航无忧产品功能！</p>
          <p>在认证前，你可先准备好相关资料，如：公司营业执照、公司的国内外银行账号等，若该公司已经经过认证，则可直接申请加入</p>
          <div class="company-name-enter">
            <div class="enter-title">企业全称</div>
            <el-form ref="companyCnName" :model="formData" :rules="formCheck">
              <el-form-item label="" prop="companyCnName">
                <el-input v-model.trim="formData.companyCnName" placeholder="请输入企业全称" maxlength="60"></el-input>
              </el-form-item>
            </el-form>
            <el-button type="primary" @click="checkCompanyName">立即认证</el-button>
          </div>
        </div>
        <!-- 认证流程-2企业名已认证 -->
        <div class="certifica-result-nav" v-if="stepIndex === 2">
          <div class="result-title">企业状态：该企业已认证</div>
          <p>您可以“申请加入”，向该企业管理员提交审核</p>
          <div style="text-align:left;padding-left:142px">
            <p>1.加入企业后您的资产将并入企业（包括充值票等）<span style="margin-left:16px">2.退出企业后资产不可回退，请谨慎加入</span></p>
            <p>3.加入企业后您可以使用企业账户的资产</p>
          </div>
          <el-button @click="stepIndex = 1">取消</el-button>
          <el-button type="primary" @click="handJoinCompany">申请加入</el-button>
        </div>
        <!-- 认证流程-3提交加入企业之后的操作提示 -->
        <div class="certifica-result-nav" v-if="stepIndex === 3">
          <div class="result-title"><img :src="imgs.success">申请成功！</div>
          <p>申请成功，请等待管理员审核！</p>
          <el-button type="primary" @click="stepIndex = 4">返回</el-button>
        </div>
        <!-- 认证流程-4加入企业在审核 -->
        <div class="certifica-result-nav" v-if="stepIndex === 4" style="padding:170px 0 0 0">
          <div class="result-title"><img :src="imgs.warning">企业状态：审核中</div>
          <p>请等待管理员审核通过，通过后自动加入该企业！</p>
        </div>
        <!-- 认证流程-5填写企业信息 -->
        <div class="company-info-nav company-info-active" v-if="stepIndex === 5">
          <el-form ref="form" :model="formData" :rules="formCheck" label-width="124px">
            <div class="block-title">填写基本信息</div>
            <el-form-item label="公司名称" prop="companyCnName">
              <el-input v-model.trim="formData.companyCnName" placeholder="请填写企业名称" :disabled="true" class="company-name-input"></el-input>
            </el-form-item>
            <el-form-item label="公司电话" prop="phone">
              <el-input size="medium" v-model.trim="formData.phone" placeholder="填写公司电话" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="公司邮箱" prop="email">
              <el-input size="medium" v-model.trim="formData.email" placeholder="填写公司邮箱" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="公司地址" prop="country">
              <regionSelect @getRegionData="getRegionData" :regionArr='regionArr' :type="3"></regionSelect>
            </el-form-item>
            <el-form-item label="公司详细地址" prop="companyAddress">
              <el-input type="textarea" size="medium" v-model.trim="formData.companyAddress" placeholder="请输入详细地址" show-word-limit></el-input>
            </el-form-item>
            <div class="block-title">填写财务信息</div>
            <el-form-item label="人民币账户" prop="rmbAccount">
              <el-input size="medium" v-model.trim="formData.rmbAccount" placeholder="请输入人民币账户" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="人民币开户行" prop="rmbAccountsBank">
              <el-input size="medium" v-model.trim="formData.rmbAccountsBank" placeholder="请输入人民币开户行信息" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="美金账号" prop="">
              <el-input size="medium" v-model.trim="formData.usdAccount" placeholder="请输入美金账户" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="美金开户行" prop="">
              <el-input size="medium" v-model.trim="formData.usdAccountsBank" placeholder="请输入美金账户开户行信息" show-word-limit></el-input>
            </el-form-item>
            <div class="block-title">上传营业执照</div>
            <el-form-item label="企业统一信用代码" prop="socialCreditCode">
              <el-input size="medium" v-model="formData.socialCreditCode" placeholder="请输入18位社会信用代码" show-word-limit maxlength="18" @input="val => toupcaseTable(val)"></el-input>
            </el-form-item>
            <el-form-item label="营业执照" prop="licensePic">
              <div class="upload">
                <!-- 图片上传之后用input表单元素触发视图更新 -->
                <el-input size="medium" v-model="formData.licensePic" type="hidden" style="display:none"></el-input>
                <div class="upload-top-tip">(提示：复印件必须加盖红章，否则无法通过审核）</div>
                <div :style="uploadImg || uploadPdf ? 'display:none':'display:block'">
                  <el-upload ref="uploadImg1" class="upload-demo" drag :limit="1" list-type="picture" :show-file-list="false" accept=".jpg,.jpeg,.png,.pdf" :action="action" :headers="headers" :on-success="uploadSuccess" :before-upload="handleUpload" :on-remove="removeImg">
                    <div class="upload-icon-box">
                      <!-- <i class="iconfont icon-tianjia1"></i> -->
                      <p><span style="color:#1170EB">点击上传</span>/拖拽到此处</p>
                      <div class="upload-tip-desc">支持JPG、JEPG、PNG、PDF格式，文件小于10MB</div>
                    </div>
                  </el-upload>
                  <!-- <div class="picture-box">
                    <el-image :src="formData.licensePic" alt="" class="el-upload-list__item-thumbnail" :preview-src-list="[formData.licensePic]"></el-image>
                  </div> -->
                </div>
                <!-- <div class="el-upload__text" style="height: 40px; line-height: 22px; color: #666;">
                    <div>注意：多证合一营业执照，照片或扫描件。</div>
                    <div>完成认证后不可更改主体，如需更改请<span style="color:#00A0E9">联系客服</span></div>
                    <div>信息需清晰可见，内容真实有效，不得做任何修改。</div>
                    <div>支持 JPG、JPEG、PNG、BMP 格式，大小不超过 5 MB。</div>
                  </div> -->
                <div class="upload-result" v-if="uploadImg && !uploadPdf">
                  <img :src="uploadImg">
                  <el-upload ref="uploadImg2" class="upload-demo" drag :limit="1" list-type="picture" :show-file-list="false" accept=".jpg,.jpeg,.png,.pdf" :action="action" :headers="headers" :on-success="uploadSuccess" :before-upload="handleUpload" :on-remove="removeImg">
                    <el-link type="primary">重新上传</el-link>
                  </el-upload>
                </div>
                <div class="upload-result" v-if="!uploadImg && uploadPdf">
                  <img :src="require('@/assets/main/pdf.png')" class="upload-pdf">
                  <el-upload ref="uploadImg2" class="upload-demo" drag :limit="1" list-type="picture" :show-file-list="false" accept=".jpg,.jpeg,.png,.pdf" :action="action" :headers="headers" :on-success="uploadSuccess" :before-upload="handleUpload" :on-remove="removeImg">
                    <el-link type="primary">重新上传</el-link>
                  </el-upload>
                </div>
              </div>
            </el-form-item>
            <div style="height: 1px;border: 1px solid #D9D9D9;margin-top:28px"></div>
          </el-form>
          <div class="form-oper-nav">
            <el-button class="step-prev-button" @click="stepIndex = 1">上一步</el-button>
            <el-button class="step-next-button submit-active" type="primary" @click="submitCompanyInfo">提交</el-button>
          </div>
        </div>
        <!-- 认证流程-6提交认证企业信息之后的操作提示 -->
        <div class="certifica-result-nav" v-if="stepIndex === 6">
          <div class="result-title"><img :src="imgs.success">提交成功！</div>
          <p>提交成功，请等待客服人员审核！</p>
          <!-- <p>大概需要2~3个工作日，审核结果会通过短信形式发送到你手机上，请注意查收～</p> -->
          <el-button type="primary" @click="stepIndex=7">返回</el-button>
        </div>
        <!-- 认证流程-7认证企业在审核 -->
        <div class="certifica-result-nav" v-if="stepIndex === 7" style="padding:170px 0 0 0">
          <div class="result-title"><img :src="imgs.warning">企业状态：审核中</div>
          <p>大概需要1个工作日～请耐心等待解锁完整e航无忧产品功能！</p>
        </div>
        <!-- 认证流程-8认证企业被驳回 -->
        <div class="certifica-result-nav" v-if="stepIndex === 8">
          <div class="result-title"><img :src="imgs.error">企业状态：认证失败</div>
          <p>企业名称：{{certificationObj.companyCnName}}</p>
          <p>原因：{{certificationObj.companyRejectReason}}</p>
          <el-button style="width:100px" @click="stepIndex = 1">回到初始状态</el-button>
          <el-button type="primary" @click="stepIndex = 5">重新认证</el-button>
        </div>
        <!-- 认证流程-9流程完毕，展示信息 -->
        <div class="company-info-nav company-info-readonly" v-if="stepIndex === 9">
          <el-form ref="form" :model="formData" :rules="formCheck">
            <div class="block-title">基本信息</div>
            <table class="company-info-table">
              <tr>
                <td>公司名称</td>
                <td class="blank-td"></td>
                <td>{{formData.companyCnName}}</td>
                <td class="blank-td"></td>
                <td colspan="2"></td>
              </tr>
              <tr>
                <td style="width:84px">公司电话</td>
                <td class="blank-td"></td>
                <td>
                  <div v-if="updateFieldName != 'phone'">{{formData.phone ? formData.phone:'-'}}</div>
                  <div class="update-info-nav" v-if="updateFieldName == 'phone'">
                    <el-form-item prop="phone">
                      <el-input v-model="formData.phone" placeholder="请输入内容"></el-input>
                    </el-form-item>
                    <el-button @click="cancelCompanyField('phone')">取消</el-button>
                    <el-button type="primary" @click="updateCompanyField('phone')">保存</el-button>
                  </div>
                </td>
                <td class="blank-td"></td>
                <td>
                  <el-link type="primary" @click="openUpdateFieldName('phone')" :underline="false" v-if="updateFieldName != 'phone'">修改</el-link>
                </td>
                <td></td>
              </tr>
              <tr>
                <td style="width:84px">公司邮箱</td>
                <td class="blank-td"></td>
                <td>
                  <div v-if="updateFieldName != 'email'">{{formData.email ? formData.email:'-'}}</div>
                  <div class="update-info-nav" v-if="updateFieldName == 'email'">
                    <el-form-item prop="email">
                      <el-input v-model="formData.email" placeholder="请输入内容"></el-input>
                    </el-form-item>
                    <el-button @click="cancelCompanyField('email')">取消</el-button>
                    <el-button type="primary" @click="updateCompanyField('email')">保存</el-button>
                  </div>
                </td>
                <td class="blank-td"></td>
                <td>
                  <el-link type="primary" @click="openUpdateFieldName('email')" :underline="false" v-if="updateFieldName != 'email'">修改</el-link>
                </td>
                <td></td>
              </tr>
              <tr>
                <td style="width:84px">公司详细地址</td>
                <td class="blank-td"></td>
                <td>
                  <div v-if="updateFieldName != 'companyAddress'">{{companySelectAddress[1]}} {{companySelectAddress[2]}} {{companySelectAddress[3]}} {{formData.companyAddress}}</div>
                  <div class="update-info-nav" v-if="updateFieldName == 'companyAddress'">
                    <el-form-item label="" prop="country" class="country-form-item">
                      <regionSelect @getRegionData="getRegionData" :regionArr='regionArr' :type="3"></regionSelect>
                    </el-form-item>
                    <div class="address-textarea">
                      <el-form-item prop="companyAddress">
                        <el-input type="textarea" size="medium" v-model="formData.companyAddress" placeholder="请输入详细地址" show-word-limit></el-input>
                      </el-form-item>
                    </div>
                    <el-button @click="cancelCompanyField('companyAddress')">取消</el-button>
                    <el-button type="primary" @click="updateCompanyField('companyAddress')">保存</el-button>
                  </div>
                </td>
                <td class="blank-td"></td>
                <td>
                  <el-link type="primary" @click="openUpdateFieldName('companyAddress')" :underline="false" v-if="updateFieldName != 'companyAddress'">修改</el-link>
                </td>
                <td></td>
              </tr>
              <tr style="opacity:0;height:0 !important">
                <td style="width:84px"></td>
                <td class="blank-td"></td>
                <td>{{formData.rmbAccount ? formData.rmbAccount:'-'}}</td>
                <td class="blank-td"></td>
                <td></td>
                <td></td>
              </tr>
            </table>
            <div class="block-title" style="margin-top:-11px">财务信息</div>
            <table class="company-info-table">
              <tr>
                <td>
                  <div v-if="updateFieldName != 'rmbAccount'">人民币账号</div>
                  <div class="td-title-div" v-else>
                    <div>人民币账号</div>
                    <div>人民币开户行</div>
                  </div>
                </td>
                <td class="blank-td"></td>
                <td>
                  <div v-if="updateFieldName != 'rmbAccount'">{{formData.rmbAccount ? formData.rmbAccount:'-'}}</div>
                  <div class="update-info-nav" v-if="updateFieldName == 'rmbAccount'">
                    <el-form-item prop="rmbAccount">
                      <el-input v-model="formData.rmbAccount" placeholder="请输入内容"></el-input>
                    </el-form-item>
                    <el-form-item prop="rmbAccountsBank">
                      <el-input v-model="formData.rmbAccountsBank" placeholder="请输入内容"></el-input>
                    </el-form-item>
                    <el-button @click="cancelCompanyField('rmbAccount')">取消</el-button>
                    <el-button type="primary" @click="updateCompanyField('rmbAccount')">保存</el-button>
                  </div>
                </td>
                <td class="blank-td"></td>
                <td>
                  <el-link type="primary" @click="openUpdateFieldName('rmbAccount')" :underline="false" v-if="updateFieldName != 'rmbAccount'">修改</el-link>
                </td>
                <td></td>
              </tr>
              <tr v-if="updateFieldName != 'rmbAccount'">
                <td style="width:84px">人民币开户行</td>
                <td class="blank-td"></td>
                <td>{{formData.rmbAccountsBank ? formData.rmbAccountsBank:'-'}}</td>
                <td class="blank-td"></td>
                <td colspan="2"></td>
              </tr>
              <tr>
                <td style="width:84px">
                  <div v-if="updateFieldName != 'usdAccount'">美金账号</div>
                  <div class="td-title-div" v-else>
                    <div>美金账号</div>
                    <div>美金开户行</div>
                  </div>
                </td>
                <td class="blank-td"></td>
                <td>
                  <div v-if="updateFieldName != 'usdAccount'">{{formData.usdAccount ? formData.usdAccount:'-'}}</div>
                  <div class="update-info-nav" v-if="updateFieldName == 'usdAccount'">
                    <el-form-item prop="usdAccount">
                      <el-input v-model="formData.usdAccount" placeholder="请输入内容"></el-input>
                    </el-form-item>
                    <el-form-item prop="usdAccountsBank">
                      <el-input v-model="formData.usdAccountsBank" placeholder="请输入内容"></el-input>
                    </el-form-item>
                    <el-button @click="cancelCompanyField('usdAccount')">取消</el-button>
                    <el-button type="primary" @click="updateCompanyField('usdAccount')">保存</el-button>
                  </div>
                </td>
                <td class="blank-td"></td>
                <td>
                  <el-link type="primary" @click="openUpdateFieldName('usdAccount')" :underline="false" v-if="updateFieldName != 'usdAccount'">修改</el-link>
                </td>
                <td></td>
              </tr>
              <tr v-if="updateFieldName != 'usdAccount'">
                <td style="width:84px">美金开户行</td>
                <td class="blank-td"></td>
                <td>{{formData.usdAccountsBank ? formData.usdAccountsBank:'-'}}</td>
                <td class="blank-td"></td>
                <td colspan="2"></td>
              </tr>
              <tr style="opacity:0">
                <td style="width:84px">公司详细地址</td>
                <td class="blank-td"></td>
                <td>{{companySelectAddress[1]}} {{companySelectAddress[2]}} {{companySelectAddress[3]}} {{oldFormData.companyAddress}}</td>
                <td class="blank-td"></td>
                <td></td>
                <td></td>
              </tr>
            </table>
          </el-form>
        </div>
        <!-- 认证流程-10提交修改企业财务信息之后的操作提示 -->
        <div class="certifica-result-nav" v-if="stepIndex === 10">
          <div class="result-title"><img :src="imgs.success">提交成功！</div>
          <p>提交成功，请等待客服人员审核！</p>
          <!-- <p>大概需要2~3个工作日，审核结果会通过短信形式发送到你手机上，请注意查收～</p> -->
          <el-button type="primary" @click="stepIndex=11">返回</el-button>
        </div>
        <!-- 认证流程-11企业财务信息在审核 -->
        <div class="certifica-result-nav" v-if="stepIndex === 11" style="padding:170px 0 0 0">
          <div class="result-title"><img :src="imgs.warning">企业状态：审核中</div>
          <p>您的修改信息已成功提交，大概需要1个工作日～请耐心等待解锁完整e航无忧产品功能！</p>
          <p></p>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { httpAjax } from "@/api/ajax"
import regionSelect from "@/components/select/RegionSelect"
import { regions } from '@/components/select/regions'
import { MODE_CONF } from '@/utils/config'
const rulePhone = /^0\d{2,4}-?\d{7,9}$/// 座机号码校验规则/^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/
//const rulePhone2 = /^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/;// 手机号码校验规则
const rulePhone2 = /^\d{11}$/;///^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/;// 手机号码校验规则

import TopTitle from '@/components/TopTitle'

const imgs = {
  success: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/status/success.png',
  warning: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/status/warning.png',
  error: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/status/error.png',
}

export default {
  components: {
    regionSelect,
    TopTitle,
  },
  name: "info",
  data () {
    const phoneValidate = async (rule, value, callback) => {
      if (value && value.length < 1 || value === undefined || value == '') {
        return callback(new Error('公司电话不能为空'))
      } else if (!rulePhone.test(value) && !rulePhone2.test(value)) {
        return callback(new Error('公司电话格式不正确'))
      } else {
        callback()
      }
    }
    const countryValidate = async (rule, value, callback) => {
      if (this.regionArr.length === 0 || !this.regionArr[0]) {
        return callback(new Error('请选择公司地址'))
      } else if (this.regionArr[0] === 'CN' && !this.regionArr[1]) {
        return callback(new Error('请选择公司省市区信息'))
      } else {
        callback()
      }
    }
    const addressValidate = async (rule, value, callback) => {
      if (value === undefined || value.length < 1) {
        return callback(new Error('请输入公司详细地址'))
      } else {
        callback()
      }
    }
    return {
      imgs,
      activeName: '1',
      uploadImg: '',//企业认证上传的图片
      uploadPdf: '',
      formData: {     //企业认证信息
        licensePic: '',
        companyCnName: '',
        country: ''
      },
      oldFormData: {},
      userData: {}, //登录的用户信息  companyUserStatus  1:在职 2:申请加入 3:取消申请/撤回申请 97:被拒绝加入 98:主动退出 99:被辞退(离职)
      certificationObj: {
        status: null //补上status初始状态，防止刷新出现内容变化的情况
      },  //企业认证信息对象 其中status 0:等待认证, 10: 认证失败, 20: 认证成功
      formDisabled: false,  //企业信息是否不可修改/只能查看
      companySelectAddress: '',
      stepIndex: 0, //认证流程步骤

      headers: { 'token': localStorage.getItem('userToken')},
      action: MODE_CONF.base_url + '/services/company/uploadLicensePic',
      isAdmin: false, // 是否管理员
      formCheck: {
        companyCnName: [{ required: true, message: '请填写企业名称', trigger: ['blur', 'change'] }],
        phone: [{ required: true, validator: phoneValidate, trigger: ['blur', 'change'] }],
        email: [{ required: true, type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }],
        country: [{ required: true, validator: countryValidate, trigger: ['blur', 'change'] }],
        companyAddress: [{ required: true, validator: addressValidate, trigger: ['blur', 'change'] }],
        rmbAccount: [{ required: true, message: '请输入人民币账户', trigger: ['blur', 'change'] }],
        rmbAccountsBank: [{ required: true, message: '请输入人民币开户行信息', trigger: ['blur', 'change'] }],
        usdAccount: [{ required: true, message: '请输入美金账户', trigger: ['blur', 'change'] }],
        usdAccountsBank: [{ required: true, message: '请输入美金账户开户行信息', trigger: ['blur', 'change'] }],
        socialCreditCode: [
          { required: true, message: '请输入社会信用代码', trigger: ['blur', 'change'] },
          { pattern: /[0-9A-Z]{18}/, message: '请输入正确的社会信用代码' }
        ],
        licensePic: [{ required: true, message: '请上传营业执照', trigger: "change" }]
      },


      joinCompanyData: {}, //申请加入的企业信息
      reUpgrade: false,  //是否属于重新认证
      regionArr: [],  //地区数据
      updateFieldName: '',
      loading: false //加载状态
    }
  },
  mounted () {
    this.isAdmin = this.$store.getters.userData.isAdmin
    this.getUserInfo()
    let domain = '';
    if (window.location.host.split('.')[0] == 'www') {
      domain = window.location.host.split('.')[1];
    } else {
      domain = window.location.host.split('.')[0];
    }
    this.headers['X-company-domain'] = domain;
  },
  methods: {
    //转大写
    toupcaseTable (val) {
      this.formData.socialCreditCode = val.toUpperCase()
    },
    getUrl (url) {
      if (!url) return
      if (url.substring(0, 4) === 'http') {
        return url
      } else {
        return 'https://' + url
      }
    },
    // 获取用户信息
    getUserInfo () {
      this.loading = true
      httpAjax({
        url: `/services/user/currentUser`,
        method: "get",
      }).then((response) => {
        if (response.success) {
          this.userData = response.data
          if (this.userData.companyUserStatus === 2) {//申请加入企业
            this.stepIndex = 4
          } else if (this.userData.companyUserStatus === 97) {//被拒绝申请加入
            this.stepIndex = 1
          }
          this.getRegistryCompany()
        } else {
          this.$message({
            message: response.msg,
            type: 'error'
          })
        }
      }).catch(() => {
        this.stepIndex = 1
      })
    },
    //获取认证的企业状态
    getRegistryCompany () {
      httpAjax({
        url: '/services/company/currentCompany',
        method: 'get',
      }).then(response => {
        if (response.success) {
          if (response.data) {
            this.certificationObj = response.data
            this.regionArr = [this.certificationObj.country, this.certificationObj.province, this.certificationObj.city, this.certificationObj.area]
            this.companySelectAddress = [regions.countryData[this.certificationObj.country], regions.data[this.certificationObj.province], regions.data[this.certificationObj.city], regions.data[this.certificationObj.area]]
            const { companyCode, companyCnName, phone, email, companyAddress, rmbAccount, rmbAccountsBank, usdAccount, usdAccountsBank, socialCreditCode, licensePic, country, province, city, area } = response.data
            this.formData = { companyCode, companyCnName, phone, email, companyAddress, rmbAccount, rmbAccountsBank, usdAccount, usdAccountsBank, socialCreditCode, licensePic }
            //备份原始数据，修改不保存，回归原始数据
            this.oldFormData = { companyCode, companyCnName, phone, email, companyAddress, rmbAccount, rmbAccountsBank, usdAccount, usdAccountsBank, socialCreditCode, licensePic, country, province, city, area }

            if (this.userData.companyUserStatus === 1 && this.certificationObj.status === 0) {//企业认证在审核
              this.stepIndex = 7
            } else if (this.userData.companyUserStatus === 1 && this.certificationObj.status === 10) {//企业认证失败
              this.stepIndex = 8
            } else if (this.userData.companyUserStatus === 1 && this.certificationObj.status === 20) {//已加入一家企业
              this.stepIndex = 9
            } else if (this.userData.companyUserStatus === 1 && this.certificationObj.status === 201) {//企业财务信息审核中
              this.stepIndex = 11
            }
            //预览展示图片/pdf
            if (this.certificationObj.licensePic.indexOf('.pdf') > -1) {
              this.uploadImg = ''
              this.uploadPdf = true
            } else {
              this.uploadImg = this.certificationObj.licenseUrl
              this.uploadPdf = false
            }
          } else {
            this.stepIndex = 1
          }
        } else {
          this.$message({
            message: response.msg,
            type: 'error'
          })
        }
      }).finally(() => {
        this.loading = false
      })
    },
    //校验公司名是否已认证
    checkCompanyName () {
      this.$refs['companyCnName'].validate((valid) => {
        if (valid) {
          httpAjax({
            url: `/services/company/company/${this.formData.companyCnName}`,
            method: 'get',
          }).then(response => {
            if (response.success) {
              if (response.data) {
                this.joinCompanyData = response.data
                response.data.status === 20 ? (this.stepIndex = 2) : null
                response.data.status === 10 ? (this.stepIndex = 5) : null
              } else {
                this.stepIndex = 5
              }
            } else {
              this.$message({
                message: response.msg,
                type: 'error'
              })
            }
          })
        }
      })
    },
    //申请加入企业
    handJoinCompany () {
      httpAjax({
        url: '/services/company/join',
        method: 'post',
        data: this.joinCompanyData.companyCode
      }).then(response => {
        if (response.success) {
          this.stepIndex = 3
        } else {
          this.$message({
            message: response.msg,
            type: 'error'
          })
        }
      })
    },
    //提交认证企业信息
    submitCompanyInfo () {
      //省市区解构赋值
      [this.formData.country, this.formData.province, this.formData.city, this.formData.area] = this.regionArr
      //第一次认证、重新认证
      var url = this.certificationObj.status === 10 ? '/services/company/reUpgrade' : '/services/company/upgrade'
      this.$refs['form'].validate((valid) => {
        if (valid) {
          httpAjax({
            url: url,
            method: "post",
            data: this.formData
          }).then((response) => {
            if (response.success) {
              this.stepIndex = 6
            } else {
              this.$message({
                message: response.msg,
                type: 'error'
              })
            }
          })
        }
      })
    },
    //取消单个企业信息修改
    cancelCompanyField (fieldName) {
      this.updateFieldName = ''
      this.formData[fieldName] = this.oldFormData[fieldName]
      if (fieldName == 'companyAddress') {
        this.regionArr = [this.oldFormData.country, this.oldFormData.province, this.oldFormData.city, this.oldFormData.area]
      } else if (fieldName == 'rmbAccount') {
        this.formData.rmbAccountsBank = this.oldFormData.rmbAccountsBank
      } else if (fieldName == 'usdAccount') {
        this.formData.usdAccountsBank = this.oldFormData.usdAccountsBank
      }
    },
    //点击修改单个企业信息
    openUpdateFieldName (fieldName) {
      this.formData[this.updateFieldName] = this.oldFormData[this.updateFieldName]
      if (this.updateFieldName == 'companyAddress') {
        this.regionArr = [this.oldFormData.country, this.oldFormData.province, this.oldFormData.city, this.oldFormData.area]
      } else if (this.updateFieldName == 'rmbAccount') {
        this.formData.rmbAccountsBank = this.oldFormData.rmbAccountsBank
      } else if (this.updateFieldName == 'usdAccount') {
        this.formData.usdAccountsBank = this.oldFormData.usdAccountsBank
      }
      this.updateFieldName = fieldName//必须放在该方法最后面
    },
    //企业单个字段信息修改
    updateCompanyField (fieldName) {
      let url = '/services/company/update'
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let params = {
            companyCode: this.formData.companyCode
          }
          if (fieldName == 'companyAddress') {
            [this.formData.country, this.formData.province, this.formData.city, this.formData.area] = this.regionArr
            params.country = this.formData.country
            params.province = this.formData.province
            params.city = this.formData.city ? this.formData.city:''
            params.area = this.formData.area ? this.formData.area:''
          } else if (fieldName == 'rmbAccount') {
            params.rmbAccountsBank = this.formData.rmbAccountsBank
            params.usdAccount = this.formData.usdAccount
            params.usdAccountsBank = this.formData.usdAccountsBank
            url = '/services/company/updatefinance'
          } else if (fieldName == 'usdAccount') {
            params.usdAccountsBank = this.formData.usdAccountsBank
            params.rmbAccount = this.formData.rmbAccount
            params.rmbAccountsBank = this.formData.rmbAccountsBank
            url = '/services/company/updatefinance'
          }
          params[fieldName] = this.formData[fieldName]
          httpAjax({
            url: url,
            method: "post",
            data: params
          }).then((response) => {
            if (response.success) {
              this.updateFieldName = ''
              //财务信息修改走审核流程
              if (fieldName == 'rmbAccount' || fieldName == 'usdAccount') {
                this.stepIndex = 10
              } else {
                this.getRegistryCompany()
                this.$message({
                  type: 'success',
                  message: '修改成功!'
                })
              }
            } else {
              this.$message({
                message: response.msg,
                type: 'error'
              })
            }
          })
        }
      })
    },
    // 上传成功
    uploadSuccess (response, file) {
      this.$refs['uploadImg1'] && this.$refs['uploadImg1'].clearFiles()
      this.$refs['uploadImg2'] && this.$refs['uploadImg2'].clearFiles()
      if (file.name.indexOf('.pdf') > -1) {
        this.uploadImg = ''
        this.uploadPdf = true
      } else {
        this.uploadImg = file.url
        this.uploadPdf = false
      }
      if (response.success) {
        this.$set(this.formData, "licensePic", response.data)
        this.isUpload = true
        this.$refs['form'].clearValidate('licensePic')
      } else {
        this.$message({
          message: response.msg,
          type: 'error'
        })
      }
      this.submiting = false
    },
    // 上传校验
    handleUpload (file) {
      if (file.type !== 'image/png' && file.type !== 'image/jpeg' && file.type !== 'application/pdf') {
        this.$message({
          message: '文件格式错误',
          type: 'error'
        })
        return false
      } else if (file.size > (1024 * 1024 * 5)) {
        this.$message({
          message: '附件不能大于5M',
          type: 'error'
        })
        return false
      }
    },
    // 删除图片
    removeImg () {
      this.isUpload = false
    },
    //获取地区选择组件的数据
    getRegionData (...data) {
      this.regionArr = data
      //this.$refs['form'].clearValidate('companyAddress');
    },
  }
}
</script>

<style scoped lang="less">
.certification-page {
  height: 100%;
  background: white;
  position: relative;
  box-sizing: border-box;
  padding: 0 24px;
  overflow: hidden;
  .certifica-result-nav {
    width: 900px;
    height: 460px;
    background: #eff5ff;
    border-radius: 16px;
    margin: 106px auto;
    text-align: center;
    padding: 126px 0 0 0;
    box-sizing: border-box;
    .el-button {
      width: 80px;
      height: 32px;
      // background: #ffffff;
      border-radius: 4px;
      border: 1px solid #e5e5e5;
      padding: 0;
    }
    .el-button + .el-button {
      margin-left: 16px !important;
    }
    .el-button--primary {
      width: 88px;
      height: 32px;
      // background: #1677ff;
      border-radius: 4px;
      border: none;
      line-height: 32px;
      padding: 0;
      margin-top: 36px;
    }
    .result-title {
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      margin-bottom: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 24px;
        height: 24px;
        margin-right: 16px;
      }
    }
    p {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #666666;
      padding: 10px 0;
    }
    .company-name-enter {
      width: 606px;
      margin: 0 auto;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-top: 44px;
      .el-form-item {
        margin: 0 !important;
      }
      .enter-title {
        flex: 1;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        margin-right: 24px;
      }
      .el-button--primary {
        width: 100px;
        height: 48px;
        margin-left: 24px;
        margin-top: 0;
      }
      /deep/.el-input {
        flex: 1;
      }
      /deep/.el-input__inner {
        width: 385px;
        height: 48px;
        border-radius: 4px;
        border: 1px solid #dddddd;
        padding-left: 18px;
        font-size: 18px;
      }
      /deep/.el-input__inner::placeholder {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
      }
      /* 谷歌 */
      /deep/.el-input__inner::-webkit-input-placeholder {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
      }
      /* 火狐 */
      /deep/.el-input__inner:-moz-placeholder {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
      }
      /*ie*/
      /deep/.el-input__inner:-ms-input-placeholder {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
      }
    }
  }
  /deep/.company-info-nav {
    .block-title {
      height: 40px;
      background: #f7f7fa;
      border-radius: 4px;
      padding-left: 16px;
      line-height: 40px;
      margin-top: 20px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
    }
    .el-form-item {
      margin-top: 24px;
      margin-bottom: 0;
    }
    .el-input__inner {
      border-radius: 4px;
      height: 32px;
      line-height: 32px;
      padding-left: 16px;
    }
    .el-form-item__label {
      color: #666666;
      line-height: 32px !important;
      height: 32px;
      padding-right: 0;
    }
    .el-form-item__content {
      margin-left: 304px !important;
      line-height: 32px !important;
      width: 500px;
    }
    .el-textarea__inner {
      height: 138px;
      padding: 6px 8px;
    }
    .company-info-table {
      tr {
        height: 40px;
        td:first-child {
          text-align: right;
          color: #666666;
          width: 90px;
        }
        .blank-td {
          width: 180px;
        }
      }
      .td-title-div {
        height: 136px;
        padding-top: 10px;
        div:first-child {
          margin-bottom: 28px;
        }
      }
    }
    .region-selects .el-select {
      width: 110px !important;
      margin-right: 20px !important;
    }
    .region-selects .el-select:last-child {
      margin-right: 0 !important;
    }
    .company-name-input.is-disabled .el-input__inner {
      background: #eff5ff !important;
      border: 1px solid #eff5ff !important;
      color: #333333 !important;
    }
  }
  .company-info-readonly {
    position: relative;
    .block-title {
      margin-top: 10px;
      margin-bottom: 12px;
      text-align: left;
    }
  }
  /deep/.upload {
    position: relative;
    .upload-top-tip {
      position: absolute;
      top: -38px;
      font-family: PingFangSC-Regular, PingFang SC;
    }
    .el-upload-dragger {
      height: 220px;
      width: 500px;
    }
    .upload-demo {
      margin-top: 38px;
    }
    .upload-tip-desc {
      font-family: PingFangSC-Regular, PingFang SC;
      color: #999999;
    }
    p {
      margin-top: 80px;
    }
    .picture-box {
      width: 180px;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 0;
      background: #f2f2f2;
      padding: 0;
      border: none;
      position: absolute;
    }
    .picture-box img {
      width: 69px;
      height: 95px;
    }
    .upload-result {
      width: 200px;
      margin-top: 38px;
      img {
        width: 200px;
        height: 260px;
      }
      .el-link.el-link--primary {
        line-height: 20px;
      }
      .upload-demo {
        margin-top: 0;
        .el-upload-dragger {
          width: 64px;
          height: 24px;
          text-align: left;
          line-height: 24px;
          border: 0;
        }
      }
      .upload-pdf {
        width: 239px;
        height: 160px;
      }
    }
  }
  .form-oper-nav {
    margin: 30px 0 58px 0;
    .step-prev-button {
      width: 80px;
      height: 32px;
      // background: #ffffff;
      border-radius: 4px;
      border: 1px solid #dedede;
      padding: 0;
      margin-left: 485px;
      margin-right: 24px;
    }
    .step-next-button {
      width: 186px;
      height: 32px;
      // background: #3083ff;
      border-radius: 4px;
      opacity: 0.5;
      padding: 0;
      border: none;
      cursor: default;
    }
    .submit-active {
      // background: #3083ff;
      opacity: 1;
      cursor: pointer;
    }
  }
  /deep/.update-info-nav {
    padding: 4px 0;
    .el-select .el-input {
      margin-bottom: 16px;
    }
    .country-form-item .el-select .el-input {
      margin-bottom: 0;
    }
    .el-input {
      // margin-bottom: 16px;
    }
    .el-button--default {
      width: 80px;
      height: 32px;
      // background: #ffffff;
      border-radius: 4px;
      // border: 1px solid #dedede;
      padding: 0;
    }
    .el-button--primary {
      width: 80px;
      height: 32px;
      // background: #1170eb;
      border-radius: 4px;
      padding: 0;
      border: 0;
    }
    .el-button + .el-button {
      margin-left: 16px;
    }
    .el-textarea__inner {
      height: 78px;
    }
    .el-form-item {
      margin-top: 0 !important;
      .el-form-item__content {
        width: 360px !important;
        margin-left: 0 !important;
        min-height: 48px;
      }
    }
    .country-form-item .el-form-item__content {
      width: 100% !important;
    }
    .address-textarea {
      .el-form-item__content {
        width: 370px !important;
        min-height: 94px;
      }
      .el-input {
        margin-bottom: 0 !important;
      }
    }
    .el-form-item__content::after,
    .el-form-item__content::before,
    .el-form-item::after,
    .el-form-item::before {
      display: none;
    }
    .el-form-item__error {
      position: relative;
      height: 24px;
      line-height: 24px;
      padding-top: 0;
    }
  }
}
</style>